import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:5000/api/v1';

/**
 * Get user notifications
 */
export const getNotifications = async (params = {}) => {
    try {
        const { limit = 20, skip = 0, unreadOnly = false } = params;
        const response = await axios.get(`${API_URL}/notifications`, {
            params: { limit, skip, unreadOnly },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
    }
};

/**
 * Get unread notification count
 */
export const getUnreadCount = async () => {
    try {
        const response = await axios.get(`${API_URL}/notifications/unread-count`, {
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching unread count:', error);
        throw error;
    }
};

/**
 * Mark notification as read
 */
export const markAsRead = async (notificationId) => {
    try {
        const response = await axios.patch(
            `${API_URL}/notifications/${notificationId}/read`,
            {},
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        console.error('Error marking notification as read:', error);
        throw error;
    }
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async () => {
    try {
        const response = await axios.patch(
            `${API_URL}/notifications/mark-all-read`,
            {},
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        console.error('Error marking all as read:', error);
        throw error;
    }
};

/**
 * Delete notification
 */
export const deleteNotification = async (notificationId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/notifications/${notificationId}`,
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        console.error('Error deleting notification:', error);
        throw error;
    }
};
